import { useMutation } from '@tanstack/react-query'
import { downloadInvoiceCsv } from 'api/admin/charges/downloadInvoiceCsv'

export function useDownloadInvoiceCsvMutation() {
  return useMutation({
    mutationFn: (invoiceId: number) => downloadInvoiceCsv(invoiceId),
  })
}
